import { render, staticRenderFns } from "./o-mobile-plan.vue?vue&type=template&id=348b8298&"
import script from "./o-mobile-plan.vue?vue&type=script&lang=js&"
export * from "./o-mobile-plan.vue?vue&type=script&lang=js&"
import style0 from "./o-mobile-plan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports